import { Component, OnDestroy, OnInit } from '@angular/core';
import { PerspectiveMenuService } from '../../../../shared/modules/perspective-menu/perspective-menu.service';

@Component({
  selector: 'app-zone-popup-new',
  templateUrl: './zone-popup-new.component.html',
  styleUrls: ['./zone-popup-new.component.scss']
})
export class ZonePopupNewComponent implements OnInit, OnDestroy {

  constructor(private perspectiveMenu: PerspectiveMenuService) {
  }

  ngOnInit(): void {
    this.perspectiveMenu.popupSizeType = 'large';
  }

  ngOnDestroy(): void {
    this.perspectiveMenu.popupSizeType = 'normal';
  }

}
